import React from 'react';
import BellIcon from 'icons/Bell.icon';
import ClockIcon from 'icons/Clock.icon';
import CalendarIcon from 'icons/Calendar.icon';
import {
  POLL_NOTIFICATION_INTENSITY,
  PollNotificationIntensity,
} from 'models/User';
import { RadioOptionNotificationProps } from './types';

export const TEMPORARY_NOTIFICATIONS_OPTIONS: {
  value: PollNotificationIntensity;
  props: RadioOptionNotificationProps;
}[] = [
  {
    value: POLL_NOTIFICATION_INTENSITY.HIGH,
    props: {
      text: 'inTheKnow',
      description: 'inTheKnowDesc',
      icon: <BellIcon />,
    },
  },
  {
    value: POLL_NOTIFICATION_INTENSITY.MEDIUM,
    props: {
      text: 'recommendedUpdates',
      description: 'recommendedUpdatesDesc',
      icon: <ClockIcon />,
    },
  },
  {
    value: POLL_NOTIFICATION_INTENSITY.LOW,
    props: {
      text: 'minimalNotifications',
      description: 'minimalNotificationsDesc',
      icon: <CalendarIcon />,
    },
  },
];
